import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import epoch from '../lib/epoch.js';
import isObject from '../lib/is_object.js';
import secs from '../lib/secs.js';
export var ProduceJWT = /*#__PURE__*/function () {
  function ProduceJWT(payload) {
    _classCallCheck(this, ProduceJWT);
    if (!isObject(payload)) {
      throw new TypeError('JWT Claims Set MUST be an object');
    }
    this._payload = payload;
  }
  _createClass(ProduceJWT, [{
    key: "setIssuer",
    value: function setIssuer(issuer) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        iss: issuer
      });
      return this;
    }
  }, {
    key: "setSubject",
    value: function setSubject(subject) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        sub: subject
      });
      return this;
    }
  }, {
    key: "setAudience",
    value: function setAudience(audience) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        aud: audience
      });
      return this;
    }
  }, {
    key: "setJti",
    value: function setJti(jwtId) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        jti: jwtId
      });
      return this;
    }
  }, {
    key: "setNotBefore",
    value: function setNotBefore(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setExpirationTime",
    value: function setExpirationTime(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setIssuedAt",
    value: function setIssuedAt(input) {
      if (typeof input === 'undefined') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: epoch(new Date())
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: input
        });
      }
      return this;
    }
  }]);
  return ProduceJWT;
}();